import React from "react";
import { graphql, useFragment, useMutation } from "react-relay";
import { WorkspaceTodoEditMainPrioritySelector_Todo$key } from "./__generated__/WorkspaceTodoEditMainPrioritySelector_Todo.graphql";
import { WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation } from "./__generated__/WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation.graphql";

import { PrioritySelector } from "../../../WorkspaceTodoSignalShared/PrioritySelector";

export function TodoPrioritySelector(props: {
  todo: WorkspaceTodoEditMainPrioritySelector_Todo$key;
  disabled?: boolean;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceTodoEditMainPrioritySelector_Todo on TodoWorkspace {
        id
        priority
        updatedAtDate {
          ...FormattedDate
          isoString
        }
      }
    `,
    props.todo
  );

  const [setPriorityMutation] =
    useMutation<WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation>(
      graphql`
        mutation WorkspaceTodoEditMainPrioritySelectorSetPriorityMutation(
          $id: ID!
          $priority: TodoPriority!
        ) @raw_response_type {
          todoWorkspace(id: $id) {
            updatePriority(newPriority: $priority) {
              id
              priority
              ...WorkspaceTodoEditMainEditedInfo_Todo
            }
          }
        }
      `
    );

  return (
    <PrioritySelector
      selectedPriority={data.priority}
      disabled={props.disabled}
      onValueChange={(prio) => {
        setPriorityMutation({
          optimisticResponse: {
            todoWorkspace: {
              updatePriority: {
                id: data.id,
                priority: prio,

                updatedBy: null,
                updatedAtDate: data.updatedAtDate
                  ? {
                      ...data.updatedAtDate,
                      __isDate: "UnzonedDate" as const,
                    }
                  : null,
              },
            },
          },
          variables: {
            id: data.id,
            priority: prio,
          },
        });
      }}
    />
  );
}
